/**
 * RadarChart export with lazy loading
 *
 * Lazy loads the Skia/Victory-based radar chart to reduce initial bundle size.
 * @module features/dashboard/components/shared/RadarChart
 */

/* eslint-disable component-structure/enforce-component-structure -- Intentional lazy wrapper pattern */
import React, { ComponentProps, lazy, memo, Suspense } from "react";

import ChartSkeleton from "@/components/molecules/ChartSkeleton";

const RadarChartView = lazy(() => import("./RadarChartView"));

/** Props for the lazy-loaded RadarChart component */
type RadarChartViewProps = ComponentProps<typeof RadarChartView>;

/**
 * Lazy-loaded RadarChart wrapper with loading fallback.
 * @param props - RadarChartView props
 */
const LazyRadarChart = memo((props: RadarChartViewProps) => (
  <Suspense
    fallback={
      <ChartSkeleton
        width={props.dimensions.width}
        height={props.dimensions.height}
      />
    }
  >
    <RadarChartView {...props} />
  </Suspense>
));

LazyRadarChart.displayName = "LazyRadarChart";

export default LazyRadarChart;
/* eslint-enable component-structure/enforce-component-structure -- Re-enable after lazy wrapper */
